export const PARTNERS_TEXT = {
    BUTTON: {
        ADD_PARTNER_SECTION: 'Додати секцію партнерів',
        ADD_PARTNER: 'Додати партнера',
        TRY_AGAIN: 'Спробувати ще',
    },
    FORM: {
        LABEL: {
            IMAGE: 'Фото',
            TITLE: 'Заголовок',
            DESCRIPTION: 'Опис',
        },
        TITLE: {
            DELETE_SECTION: 'Видалити секцію',
            PUBLISH_SECTION: 'Опублікувати нову секцію?',
            DELETE_PARTNER: 'Видалити партнера?',
        },
        MESSAGE: {
            FAIL_TO_DELETE_PARTNER_SECTION: 'Виникла помилка під час видалення секції партнерів',
            DELETE_SECTION_WARNING: 'Всі партнери в секції будуть видалені. Бажаєте продовжити?',
        },
        IMAGE: {
            ADD_IMAGE_HERE: 'Додайте файл сюди',
            FORMAT_ERROR: 'Невірний формат фото, дозволено jpeg, jpg, png, webp',
        },
    },
    BANNER: {
        ADD_IMAGE_HERE: 'Додайте файл сюди',
        TITLE_PLACEHOLDER: 'Введіть заголовок',
    },
    SECTION: {
        TITLE_PLACEHOLDER: 'Введіть заголовок секції',
        DESCRIPTION_PLACEHOLDER: 'Введіть опис секції',
        EMPTY_MESSAGE: 'Додайте хоча б одного партнера до секції',
        ADD_PARTNER: 'Додати партнера',
        DELETE_SECTION: 'Видалити секцію',
    },
    PARTNER: {
        IMAGE_LABEL: 'Фото',
        DESCRIPTION_LABEL: 'Опис',
        DESCRIPTION_PLACEHOLDER: 'Введіть опис партнера',
        DELETE: 'Видалити партнера',
        EDIT: 'Редагувати партнера',
    },
    MESSAGE: {
        SECTION_CREATED: 'Секція успішно створена',
        SECTION_UPDATED: 'Секція успішно оновлена',
        SECTION_DELETED: 'Секція успішно видалена',
        SECTION_PUBLISHED: 'Секція успішно опублікована',
        BANNER_PUBLISHED: 'Зміни успішно опубліковано',
        FAIL_TO_LOAD_PARTNERS: 'Виникла помилка, не вдалося завантажити партнерів',
        FAIL_TO_UPDATE_BANNER: 'Виникла помилка під час оновлення банера',
        FAIL_TO_CREATE_SECTION: 'Виникла помилка під час створення секції',
        FAIL_TO_PUBLISH_SECTION: 'Виникла помилка під час публікації секції',
        FAIL_TO_DELETE_SECTION: 'Виникла помилка під час видалення секції',
        FAIL_TO_LOAD_BANNER: 'Виникла помилка під час завантаження банеру',
        FAIL_TO_TRANSLATE_BANNER: 'Виникла помилка під час додавання перекладу для банера',
        FAIL_TO_UPDATE_TRANSLATION_FOR_BANNER: 'Виникла помилка під час оновлення перекладу для банера',
        FAIL_TO_TRANSLATE_SECTION: 'Виникла помилка під час додавання перекладу для секції партнерів',
        FAIL_TO_UPDATE_TRANSLATION_FOR_SECTION: 'Виникла помилка під час оновлення перекладу для секції партнерів',
        FAIL_TO_LOAD_TRANSLATION_FOR_SECTION: 'Виникла помилка під час завантаження перекладу для секції партнерів',
    },
};

export const PARTNER_BANNER_VALIDATION = {
    title: {
        min: 10,
        max: 30,
        getRequiredError: () => `Заголовок обов'язковий`,
    },
    description: {
        min: 10,
        max: 30,
        getRequiredError: () => `Опис обов'язковий`,
    },
    image: {
        width: 1440,
        height: 860,
        getFormatError: () => PARTNERS_TEXT.FORM.IMAGE.FORMAT_ERROR,
    },
};

export const PARTNER_SECTION_VALIDATION = {
    title: {
        min: 10,
        max: 50,
        getRequiredError: () => `Заголовок обов'язковий`,
    },
    description: {
        min: 10,
        max: 70,
        getRequiredError: () => `Опис обов'язковий`,
    },
    partners: {
        max: 30,
        getAtLeastOnePartnerRequiredError: () => 'Потрібен хоча б один партнер',
        getMaxError: () => `Максимум ${PARTNER_SECTION_VALIDATION.partners.max} партнерів`,
    },
};

export const PARTNER_VALIDATION = {
    description: {
        min: 5,
        max: 50,
        getRequiredError: () => `Опис обов'язковий`,
    },
    image: {
        width: 200,
        height: 200,
        getFormatError: () => PARTNERS_TEXT.FORM.IMAGE.FORMAT_ERROR,
    },
};
